import {
  AUTH_START,
  AUTH_STOP,
  LOGIN_GUEST,
  LOGIN_USER,
  LOGOUT_USER,
  SET_VEHICLE, USER_ERROR,
  USER_GUEST,
  USER_KEY,
} from '../constants/user'
import { clear, get, save } from '../services/storage'
import ApiError, { logError } from '../utils/errors'
import { __ } from '../services/translate'
import { showError } from './app'

export const loginGuest = () => {
  save(USER_KEY, USER_GUEST)
  return {
    type: LOGIN_GUEST,
    payload: null
  }
}

export const checkUserSession = () => (dispatch) => {
  dispatch({
    type: AUTH_START,
    payload: null
  })
  const driverNumber = get(USER_KEY)
  if (driverNumber) {
    if (driverNumber === USER_GUEST) {
      dispatch(loginGuest())
      return
    }
    dispatch(loginUser(driverNumber))
  } else {
    dispatch({
      type: AUTH_STOP,
      payload: null
    })
  }
}

export const loginUser = (driverNumber) => async (dispatch, getState, api) => {
  try {
    const user = await api.login(driverNumber)
    save(USER_KEY, user.number)
    dispatch({
      type: LOGIN_USER,
      payload: {
        id: user.id,
        name: `${user.firstname} ${user.lastname}`,
        email: user.email,
        phone: user.phone,
        number: user.number,
        licences: user.licences,
        subjects: user.subjects,
        documents: user.documents.map(document => ({
          id: document.id,
          file_id: document.file_id,
          name: document.name,
          size: document.size,
          published_at: document.published_at
        })),
      }
    })
  } catch (e) {
    dispatch({
      type: AUTH_STOP,
      payload: null
    })
    if (e instanceof ApiError && e.statusCode === 401) {
      dispatch(userError(__('Uživatel se zadaným číslem karty neexistuje')))
      return
    }
    logError(e)
    dispatch(showError(__('Nastal problem při prihlašovaní použivatele')))
  }
}

export const logout = () => {
  clear(USER_KEY)
  return {
    type: LOGOUT_USER,
    payload: null
  }
}

export const setVehicle = (vehicleType) => ({
  type: SET_VEHICLE,
  payload: vehicleType
})

export const userError = (err) => ({
  type: USER_ERROR,
  payload: err
})
